import Vue from "vue";
//scripts gerados a partir dos gerados pelo webChats, consultar
const lang = Vue.prototype.$lang_.getLang().title || "pt";
let imgSrc = require("@/assets/images/sacDesktop-pt-BR.png");
if (lang === "es") {
    imgSrc = require("@/assets/images/sacDesktop-es-ES.png");
} else if (lang === "en") {
    imgSrc = require("@/assets/images/sacDesktop-en-US.png");
} else {
    imgSrc = require("@/assets/images/sacDesktop-pt-BR.png");
}

const mobile = require("@/assets/images/sacMobile.png");
export const deskManager = {
    openedBy: null,

    dwhatToggle() {
        const message = Vue.prototype.$t_("whatsapp_mensagem");
        window.open(`https://api.whatsapp.com/send/?phone=555121068022&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`, "_blank");
    },
    dwhatLoad() {
        var e = document.createElement("style");
        (e.innerHTML = `.dwhatC::before{background:url(${imgSrc})top center no-repeat;background-size: cover;}.dwhatO::before{background:url(${imgSrc})top 
			center no-repeat;background-size: cover;}#dwhats{width:168px;height:106px;display:block;cursor: pointer;}
            @media(max-width:958px){#dwhats{width:120px;height: 120px;}.dwhatO::before{background:url(${mobile})top 
			center no-repeat;background-size: cover;}.dwhatC::before{background:url(${mobile})top center no-repeat;background-size: cover;}}
            #dwhats{position:fixed;bottom:48px;z-index:10;display:flex;align-items:center;right:15px;}
			#dwhats::before{content:\"\";width:100%;height:100%;display: block;}`),
            document.head.appendChild(e);
        let link = document.createElement("a");
        link.addEventListener("click", () => {
            this.dwhatToggle('icon');
        });
        (link.id = "dwhats"),
            (link.className = "dwhatO"),
            link.classList.add("animate__animated", "animate__fadeInUp");
        document.body.appendChild(link);
    },
};
